import axios from 'axios'

// Guard for SSR: `document` is undefined when this module is evaluated on the server.
let csrfToken =
  typeof document !== 'undefined'
    ? (document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? '')
    : ''

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

// Attach Rails CSRF token to every mutating request
api.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase()
  if (method && ['post', 'put', 'patch', 'delete'].includes(method)) {
    config.headers['X-CSRF-Token'] = csrfToken
  }
  return config
})

// Keep CSRF token fresh from server response headers
api.interceptors.response.use(
  (response) => {
    const newToken = response.headers['x-csrf-token']
    if (newToken) {
      csrfToken = newToken
    }
    return response
  },
  (error) => Promise.reject(error),
)

export default api
